// function checkCountry()
// {
//     fetch("https://ipinfo.io/json")
//   .then(response => response.json())
//   .then(data => {
//     const userCountry = data.country;
//     const alreadyRedirected = sessionStorage.getItem("redirectedCountry");

//     // Don't redirect if already done in this session
//     if (alreadyRedirected === userCountry) return;

//     let targetUrl = "";
// // alert();
//     if (userCountry === "DE") {
//       targetUrl = "https://elephantliving.com/de-de";
//     } else if (userCountry === "GB") {
//       targetUrl = "https://elephantliving.com/en-gb";
//     }else{
//         targetUrl = "https://elephantliving.com";  
//     }

//     if (targetUrl && window.location.href !== targetUrl) {
//       sessionStorage.setItem("redirectedCountry", userCountry);
//       window.location.href = targetUrl; // perform redirect
//     }
//   })
//   .catch(err => {
//     console.warn("GeoIP failed:", err);
//   });
// }



// checkCountry();

// auto redirection country region user uk , german, defualt country 

// function checkCountry() {
//     fetch("https://ipinfo.io/json")
//       .then(response => response.json())
//       .then(data => {
//         const userCountry = data.country;
//         const alreadyRedirected = sessionStorage.getItem("redirectedCountry");
  
//         if (alreadyRedirected === userCountry) return;
  
//         const origin = window.location.origin;
//         const pathname = window.location.pathname;
  
//         let langPrefix = '';
  
//         if (userCountry === "DE") {
//           langPrefix = "/de-de";
//         } else if (userCountry === "GB") {
//           langPrefix = "/en-gb";
//         } else {
//           langPrefix = ""; // default
//         }
  
//         // Remove any existing /de, /de-de, /en-gb, etc.
//         const cleanedPath = pathname.replace(/^\/(en|de)(-[a-z]{2})?(\/|$)/, '/');
  
//         const targetUrl = `${origin}${langPrefix}${cleanedPath}`;
  
//         if (window.location.href !== targetUrl) {
//           sessionStorage.setItem("redirectedCountry", userCountry);
//           window.location.href = targetUrl;
//         }
//       })
//       .catch(err => {
//         console.warn("GeoIP failed:", err);
//       });
//   }
  
//   document.addEventListener("DOMContentLoaded", checkCountry);
  
//   checkCountry();




// window.addEventListener("DOMContentLoaded", () => {
    function languageHandler(e) {
      const selectedLang = e.target.value.toLowerCase(); // 'en' or 'de'
      const userCountry = sessionStorage.getItem("redirectedCountry") || 'OTHER';
      const origin = window.location.origin;
      const pathname = window.location.pathname;
  
      let langCountrySegment = '';
  
      if (userCountry === 'GB' || userCountry === 'DE') {
        langCountrySegment = `/${selectedLang}-${userCountry.toLowerCase()}`;
      } else {
        langCountrySegment = selectedLang === 'de' ? '/de' : '';
      }
  
      // Remove any existing /en-xx, /de-xx, or /de prefix
      const cleanedPath = pathname.replace(/^\/(en|de)(-[a-z]{2})?(\/|$)/, '/');
  
      const newUrl = `${origin}${langCountrySegment}${cleanedPath}`;
  
      if (window.location.href !== newUrl) {
        window.location.href = newUrl;
      }
    }
  
    document.querySelectorAll(".top-header__lan-select").forEach((elm) => {
        // checkCountry();
      elm.addEventListener("change", languageHandler);
    });
//   });
  




















// // Language Switch Handler
// window.addEventListener("DOMContentLoaded", () => {
//   function languageHandler(e) {
//     const selectedLang = e.target.value.toLowerCase(); // 'en' or 'de'
//     const origin = window.location.origin;
//     const userCountry = sessionStorage.getItem("redirectedCountry") || "INTL";

//     let langPath = "";

//     if (userCountry === "DE" || userCountry === "GB") {
//       langPath = `/${selectedLang}-${userCountry.toLowerCase()}`; // /en-de, /de-gb, etc.
//     } else {
//       langPath = selectedLang === "de" ? "/de" : ""; // /de or default
//     }

//     const newUrl = `${origin}${langPath}`;
//     if (window.location.pathname !== langPath) {
//       window.location.href = newUrl;
//     }
//   }

//   document.querySelectorAll(".top-header__lan-select").forEach((elm) => {
//     checkCountry();
//     elm.addEventListener("change", languageHandler);
//   });
// });



























// old code 
// fetch("https://ipinfo.io/json")
// .then(response => response.json())
// .then(data => {
//   const userCountry = data.country;
//   console.log("User country:", userCountry);

//   const currencySelect = document.querySelector("#currency__change");
//   const localizationForm = currencySelect?.closest("form");
//   const alreadyRedirected = sessionStorage.getItem("redirectedCountry");
//   console.log("Al " + alreadyRedirected);
//     if( userCountry == "DE"){
      
//         $(".product-hero__delivery-othersCountry").hide();
//         $(".product-hero__delivery-german").show();
    
//     }
//     else if(userCountry == 'GB'){
//       $(".product-hero__delivery-othersCountry").hide();
//       $(".product-hero__delivery-german").hide();
//       $(".product-hero__delivery-uk").show();
//     }
//   if (alreadyRedirected != userCountry) {

//     const option = currencySelect.querySelector(`option[value='${userCountry}']`);
 
//     if (option.value) {
     
//       currencySelect.value = userCountry;
//       sessionStorage.setItem("redirectedCountry", userCountry);
//       localizationForm.submit();
//     }


//   }

// })
// .catch(err => {
//   console.warn("GeoIP failed:", err);
// });
